import styled from "@emotion/styled";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
`;

const HorizontalCenter: React.FC = ({ children }) => {
  return <Wrapper>{children}</Wrapper>;
};

export default HorizontalCenter;
